// HeaderPlatform.jsx
import React from "react";
import { FiHome, FiBell, FiLogOut } from "react-icons/fi";
import { LanguageSwitcher } from "../../components/LanguageSwitcher";
import { useNavigate } from "react-router-dom";
import { useCurrentLang } from "../../hooks/useCurrentLang";
import whitelogo from "../../images/white-logo.png"
import { useAuth } from "../../auth";
import { headerPlatformContent } from "../data/headerPlatformContent";
const HeaderPlatform = ({
  companyName = "Revimo",
}) => {
  const {user, logout} = useAuth();
  
  const navigate = useNavigate();
  const currentLang = useCurrentLang();

  const t = headerPlatformContent[currentLang]
  
  const goHome = () => {
  navigate(`/${currentLang}`)
  };
  const goPlatformHome = ()=>{
    navigate(`/${currentLang}/platform`)
  };
  const goPlatformExercises = ()=>{
    navigate(`/${currentLang}/platform/exercises`)
  };
  const goPlatformNotifications = () =>{
    navigate(`/${currentLang}/platform/notifications`)
  };
  const goLogOut = async () => {
    try {
      await logout(); // calls api_logout.php and clears userId
    } catch (e) {
      console.error(e);
    } finally {
      navigate(`/${currentLang}`, { replace: true });
    }
  };

  return (
    <header className="platform-header">
      <div className="platform-header-inner">
        {/* Left: company pill */}
        <div className="platform-header-company">
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div
              style={{
                width: 36,
                height: 36,
                borderRadius: "999px",
                backgroundColor: "var(--primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 700,
                fontSize: 18,
                maxHeight: "50px",
              }}
            >
              <img src={whitelogo} alt="logo" className="logo" style={{
        width: 28,          
        height: 28,
        objectFit: "contain",
        display: "block",
      }} />
            </div>
            <span
              style={{
                fontWeight: 700,
                fontSize: 20,
                letterSpacing: 0.3,
                color: "white",
              }}
            >
            <button
            type="button"
            onClick={goHome}
            style={{
              fontWeight: 700,
              fontSize: 20,
              letterSpacing: 0.3,
              color: "white",
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            Revimo
          </button>
            </span>
            <div style={{ display: "flex", gap: 8 }}>
              <LanguageSwitcher />
            </div>
          </div>
          </div>

        {/* Right: single glass card */}
        <div className="platform-header-right">
          <div className="platform-user-block">
            <span className="platform-user-name">{user?.name || ""}</span>
            <button
              type="button"
              className="platform-icon-button"
              onClick={goPlatformHome}
              aria-label="Platform home"
            >
              <FiHome />
            </button>
          </div>

          <div className="platform-actions-block">
           
            <button
              type="button"
              className="platform-chip-button"
              onClick={goPlatformNotifications}
            >
              <FiBell style={{ marginRight: 6 }} />
              {t.notif}
            </button>

            <button
              type="button"
              className="platform-chip-button platform-danger-chip"
              onClick={goLogOut}
            >
              <FiLogOut style={{ marginRight: 6 }} />
              {t.signout}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderPlatform;
